import HeroImg from "../assets/hero.png";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

export default function Hero() {
  return (
    <section
      className="relative flex flex-col-reverse lg:flex-row items-center justify-between gap-12 
      px-6 md:px-12 lg:px-24 xl:px-32 2xl:px-48 py-28 min-h-screen bg-black text-white overflow-hidden"
    >
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-cyan-600/30 via-transparent to-black animate-pulse blur-3xl" />

      {/* Left - Image */}
      <motion.div
        initial={{ opacity: 0, x: -60 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className="relative w-full lg:w-1/2 flex justify-center z-10"
      >
        <motion.div
          className="p-4 rounded-2xl bg-white/10 backdrop-blur-lg shadow-2xl border border-white/10 w-full max-w-md"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <motion.img
            src={HeroImg}
            alt="Vcode Freelance Hero"
            className="rounded-lg w-full h-auto shadow-xl pointer-events-none select-none"
            animate={{ y: [0, -10, 0] }}
            transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
            draggable="false"
            onContextMenu={(e) => e.preventDefault()}
          />
        </motion.div>
      </motion.div>

      {/* Right - Content */}
      <motion.div
        initial={{ opacity: 0, x: 60 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className="w-full lg:w-1/2 text-center lg:text-left z-10 space-y-6"
      >
        <motion.h1
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="text-[clamp(2.2rem,4.5vw,3.5rem)] font-extrabold bg-gradient-to-r from-cyan-300 via-blue-200 to-white bg-clip-text text-transparent leading-tight tracking-normal"
        >
          Shaping Tomorrow’s <br />
          <span className="inline-block mt-2">Digital Future</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-base sm:text-lg md:text-xl text-gray-300 max-w-xl mx-auto lg:mx-0"
        >
          Transform your vision into reality with AI-driven, scalable, and cutting-edge digital solutions. 🚀
        </motion.p>

        {/* Buttons */}
        <div className="flex flex-wrap justify-center lg:justify-start gap-4 pt-3">
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.98 }}
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-cyan-500 hover:to-blue-600 text-white rounded-full font-semibold transition-all duration-200 shadow-lg"
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
          >
            Get Started 🚀
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.98 }}
            className="px-6 py-3 border border-gray-600 text-white rounded-full font-semibold transition-all duration-200 hover:bg-gray-800 shadow-md"
            onClick={() => document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" })}
          >
            View Projects
          </motion.button>
        </div>

        {/* Social Icons */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.3 }}
          className="flex justify-center lg:justify-start gap-6 text-2xl pt-4 text-gray-400"
        >
          <motion.div whileHover={{ scale: 1.2 }} className="hover:text-white cursor-pointer">
            <FaGithub onClick={() => window.open("https://github.com", "_blank")} />
          </motion.div>
          <motion.div whileHover={{ scale: 1.2 }} className="hover:text-blue-500 cursor-pointer">
            <FaLinkedin onClick={() => window.open("https://linkedin.com", "_blank")} />
          </motion.div>
          <motion.div whileHover={{ scale: 1.2 }} className="hover:text-red-400 cursor-pointer">
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info.vcodefreelance@gmail.com" target="_blank">
              <FaEnvelope />
            </a>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
}
